

import { Component, ChangeDetectionStrategy, ViewContainerRef, ComponentFactoryResolver, AfterViewInit, ChangeDetectorRef, input, output, inject, viewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'empty-state-container',
  templateUrl: './empty-state-container.component.html',
  styleUrls: ['./empty-state-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule]
})
export class EmptyStateContainerComponent implements AfterViewInit {
  private componentFactoryResolver = inject(ComponentFactoryResolver);
  changeDetectorRef = inject(ChangeDetectorRef);

  readonly emptyState = input(new BehaviorSubject(null));
  readonly emptyComponent = viewChild('emptyStatecontainer', { read: ViewContainerRef });
  readonly onAction = output();
  componentRef: any;
  hasCustomComponent = false;

  ngAfterViewInit(): void {
    this.lazyLoadTableData();
  }

  lazyLoadTableData() {
    const emptyComponentRef = this.emptyComponent();
    if (!emptyComponentRef) return;

    this.emptyState().subscribe((comp: any) => {
      emptyComponentRef.clear();
      if (comp) {
        this.hasCustomComponent = true;
        this.componentRef = emptyComponentRef.createComponent(this.componentFactoryResolver.resolveComponentFactory(comp));
        this.componentRef.instance?.onAction?.subscribe((data: any) => {
          this.onAction.emit(data);
        });
      } else {
        this.hasCustomComponent = false;
      }
      this.changeDetectorRef.detectChanges();
    });
  }

}